import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'
import { ICurrentProfit, NFTItemType } from './type'

export const getListNFT = (): Promise<NFTItemType[]> => {
  return new Promise<any>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const getCurrentProfit = () => {
  return new Promise<ICurrentProfit>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/current-profit`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const getPriceMBC = () => {
  return new Promise<{ price: number }>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/price-mbc/1`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const getPriceMBCOrigin = () => {
  return new Promise<{ price: number }>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/price-mbc-origin/1`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export type BuyMBCStatus = 'PROCESSING' | 'SWAPPING' | 'ERROR' | 'COMPLETED'
export interface IBuyMBCResponse {
  _id: string
  updatedAt: Date
  createdBy?: string
  userId: string
  amountIn: number
  amountOut: number
  status: BuyMBCStatus
  error?: string
  createdAt: Date
  id: string
}

export const getBuyMBCStatus = () => {
  return new Promise<IBuyMBCResponse>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/buy-mbc-status`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const getAmountMBCSwap = (amount: number) => {
  return new Promise<{ amount: number }>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/amount-mbc-swap/${amount}`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export const buyMBC = (amount: number) => {
  return new Promise<unknown>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/buy-mbc`, {
          method: 'POST',
          body: JSON.stringify({ amount }),
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}
